// 27/10/2023 - SteveF - DO369719 - Added TinyURL Support
import React from 'react'
import {useLocation} from 'react-router-dom'
import {useNavigate} from 'react-router'
import {useTranslation} from 'react-i18next'
import {AxiosInstance} from 'axios'
import url from '../services/url'
import httpClient from '../services/index'
import 'regenerator-runtime/runtime'

let RedirectionPath: string

const checkStringAlphanumeric = function (String: string) {
  const regex = /^[A-Za-z0-9]*$/

  return regex.test(String)
}

const tinyURLCheckRequest = async (TinyURL: string) => {
  let navigateTo: string
  const getRedirectURLClient: AxiosInstance = httpClient.instance

  try {
    const response = await getRedirectURLClient.get(url.checkTinyURL(TinyURL))
    navigateTo = response.data.redirectionURL
  } catch (error) {
    navigateTo = '/500'
  }

  return navigateTo
}

const lookupTinyURL = async (TinyURL: string) => {
  try {
    let skipLookup = false
    let redirectionURL = ''

    // If it's not alphanumeric, this is not a TinyURL
    if (!checkStringAlphanumeric(TinyURL)) {
      skipLookup = true
      redirectionURL = ''
    }

    if (!skipLookup) {
      redirectionURL = await tinyURLCheckRequest(TinyURL)
    }

    // if we didn't get a match, not found
    if (
      redirectionURL === '' ||
      redirectionURL === null ||
      redirectionURL === undefined
    ) {
      RedirectionPath = '/notFound'
      // we did match so lets re-direct to what we got back
    } else {
      RedirectionPath = redirectionURL
    }
  } catch (error) {
    RedirectionPath = '/500'
  }
}

const TinyURLCheck = function () {
  const {t} = useTranslation()
  // Get the part of the URL that could be a TinyURL
  const location = useLocation()
  const searchPath = location.pathname.replace('/', '')

  // If it is alphanumeric then lets look it up and see!
  const navigate = useNavigate()
  const doLookup = lookupTinyURL(searchPath)
  doLookup.then(function () {
    // Once we have the path, lets go
    navigate(RedirectionPath)

    // This works around a react-router bug where components sometimes choose not to load on a navigate.
    navigate(0)
  })

  return <>{t('tinyURL.loadingtext')}</>
}

export default TinyURLCheck
